module.exports = __webpack_public_path__ + "img/book.0e4ffcad.svg";